import FolderIcon from '@mui/icons-material/Folder';
import TreeItem from '@mui/lab/TreeItem';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

const FolderItem = ({ folder, tabSelectedHandle }) => {
  return (
    <>
      <TreeItem
        nodeId={folder.id}
        label={folder.nameDirectory}
        icon={<FolderIcon sx={{ color: '#999693' }} />}
        onClick={() => tabSelectedHandle(folder.id)}
        expandIcon={<ArrowRightIcon />}
      >
        {folder.children.map((childFolder) => (
          <FolderItem
            key={childFolder.id}
            folder={childFolder} 
            tabSelectedHandle={tabSelectedHandle} />
        ))}
      </TreeItem>
    </>
  );
};

export default FolderItem;
